import React, { FC } from 'react';
import { makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { LastSnapshot } from './serialNumbers';

const usesStyles = makeStyles(theme => ({
  row: {
    backgroundColor: theme.palette.common.white
  },
  alternateRow: {
    backgroundColor: '#eee'
  }
}));

export const SerialNumberConfiguration: FC<{ configuration?: LastSnapshot; isLoading?: boolean }> = ({
  configuration,
  isLoading
}) => {
  const { t } = useTranslation();
  const classes = usesStyles();

  return (
    <TableContainer component={Paper} variant="outlined" style={{ marginTop: 20 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <b>{t('components.name')}</b>
            </TableCell>
            <TableCell align="right">
              <b>{t('products.name')}</b>
            </TableCell>
            <TableCell align="right">
              <b>{t('label.serial number')}</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {configuration && !isLoading
            ? configuration.components.map((component, key) => (
                <TableRow key={key} className={key % 2 === 1 ? classes.row : classes.alternateRow}>
                  <TableCell>{component.name}</TableCell>
                  <TableCell align="right">{component.product.name}</TableCell>
                  <TableCell align="right">{component.product.serial_number}</TableCell>
                </TableRow>
              ))
            : [0, 1, 2].map((_, key) => (
                <TableRow key={key}>
                  <TableCell>
                    <Skeleton variant="text" animation="wave" width="50%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" animation="wave" width="50%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" animation="wave" width="50%" />
                  </TableCell>
                </TableRow>
              ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
